import { logger } from '../utils/logger.js'
import { authService } from '../services/auth/auth-service.js'

const log = logger.create('sync-push-scheduler')

let pushDebounceTimer: ReturnType<typeof setTimeout> | null = null

/** Debounced push — call after any local change to sync within 2 seconds */
export function schedulePush(): void {
  if (!authService.getAccessToken()) return
  if (pushDebounceTimer) clearTimeout(pushDebounceTimer)
  pushDebounceTimer = setTimeout(async () => {
    pushDebounceTimer = null
    try {
      const { pushPendingChanges } = await import('./sync-push-handler.js')
      const { createContextSyncApi } = await import('./context-sync-api.js')
      const { environment } = await import('../environments/environment.prod.js')
      const baseUrl = environment.api.baseUrl
      const api = createContextSyncApi(baseUrl, async () => {
        const token = authService.getAccessToken()
        if (!token) throw new Error('Not authenticated')
        return token
      })
      await pushPendingChanges(api)
    } catch (err) {
      log.error('Immediate push failed:', err)
    }
  }, 2000)
}
